import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import AccordionContext from "react-bootstrap/AccordionContext";
import {
  Col,
  Container,
  Image,
  Row
  } from 'react-bootstrap';
import format from 'date-fns/format';

//#region COMPONENTS
import CollapseToggler from '../../../shared/CollapseToggler';
import EPGProgramDetails from '../EPGProgramDetails';
//#endregion

import { getContentImageByMode } from '../../../../utils/imageUtils';
import './styles.scss';

function ContextAwareToggle({ children, eventKey, callback }) {
  const currentEventKey = React.useContext(AccordionContext);

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <div  href={`#collapse-content-${eventKey}`}>
      <CollapseToggler
        onClick={decoratedOnClick}
        isOpen={isCurrentEventKey}
      />
    </div>
  );
};

function EPGProgramItem(props) {
  const {
    content,
    imageMode,
    itemHeight
  } = props;
  const keyID = `tbxEPGProgramItem-${content.cid}`;
  const imageData = getContentImageByMode(content.images, imageMode);

  return (
    <Container
      className="tbxEPGProgramItem"
      id={keyID}
    >
      <Card>
          <Row>
            <Col className="tbxEPGProgramItem__side-col">
              <div className="tbxEPGProgramItem__hour">
                <p>{format(Date.parse(content.startTime), 'HH:mm')}</p>
              </div>
            </Col>
            <Col xs={8}>
              <Row>
                <Image
                  className="tbxEPGProgramItem__image"
                  src={imageData.url}
                  style={{ height: `${itemHeight}px` }}
                  thumbnail
                />
                <div className="tbxEPGProgramItem__resume">
                  <h3 className="tbxEPGProgramItem__resume-title">{content.title}</h3>
                  <p className="tbxEPGProgramItem__resume-detail">
                    {
                      //season && `${season} ${episode} ${props.episodeTitle || ''}`
                    }
                  </p>
                </div>
              </Row>
            </Col>
            <Col className="tbxEPGProgramItem__side-col">
              <ContextAwareToggle eventKey={keyID} />
            </Col>
          </Row>
        <Accordion.Collapse eventKey={keyID}>
          <Card.Body className="tbxEPGProgramItem__details">
            <EPGProgramDetails content={content} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Container>
  );
};

EPGProgramItem.propTypes = {
  content: PropTypes.shape({
    cid: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  imageMode: PropTypes.string.isRequired,
  itemHeight: PropTypes.number.isRequired
};

export default React.memo(EPGProgramItem);
